module.exports = __webpack_public_path__ + "img/AuburnDev-Logo-Black.3a4f0491.png";